var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGardening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CCF040",
    d: "M22.426 9.938c.005-.105.01-.21.01-.316 0-3.822-3.1-6.92-6.922-6.92-3.822 0-6.92 3.098-6.92 6.92 0 .106.003.21.008.316h13.824z",
    transform: "translate(.858 .846)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCF040",
    d: "M26.62 8.849c.002-.073.005-.147.005-.22 0-2.674-2.166-4.839-4.838-4.839S16.95 5.955 16.95 8.628c0 .074.002.148.005.22h9.665z",
    transform: "translate(.858 .846)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91D9BF",
    d: "M9.816 17.471l1.72 5.314c.176.545.945.55 1.127.006l1.783-5.315c.09-.268-.11-.544-.39-.544h-3.847c-.28 0-.479.273-.393.539M26.973 21.76L25.287 23.404 20.671 17.33 22.357 15.686zM3.557.979L.335.954.365 2.701 2.458 2.622 7.315 11.405 8.854 10.555 3.56.978z",
    transform: "translate(.858 .846)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91D9BF",
    d: "M28.922 21.76c0 2.147-1.74 3.886-3.887 3.886-2.144 0-3.885-1.74-3.885-3.886s1.74-3.886 3.885-3.886c2.147 0 3.887 1.74 3.887 3.886",
    transform: "translate(.858 .846)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36947D",
    d: "M26.973 21.76c0 1.07-.867 1.938-1.937 1.938s-1.937-.868-1.937-1.938c0-1.069.867-1.937 1.937-1.937s1.937.868 1.937 1.937",
    transform: "translate(.858 .846)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91D9BF",
    d: "M21.675 17.596H10.146c-.167 0-.318-.1-.382-.254l-3.732-8.97C5.92 8.1 6.12 7.8 6.414 7.8H27.54c.328 0 .525.364.345.639l-5.864 8.97c-.076.117-.206.187-.346.187",
    transform: "translate(.858 .846)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGardening);
export default __webpack_public_path__ + "static/media/gardening.67377fd0206af0ea5642fe9e3ef51ab2.svg";
export { ForwardRef as ReactComponent };